document.addEventListener("DOMContentLoaded", function() {
    const viewMoreButton = document.getElementById('view-more-button');
    const hiddenRows = document.querySelectorAll('.view-more-row.hidden');

    if (viewMoreButton) {
        viewMoreButton.addEventListener('click', function() {
            hiddenRows.forEach(row => row.classList.remove('hidden'));
            viewMoreButton.style.display = 'none';
        });
    }
});